import * as React from "react";

const SvgIcnGroupCallBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M17 8a2 2 0 110-4 2 2 0 010 4zm2.003 1A2.997 2.997 0 0122 11.997v.503a.5.5 0 01-.5.5H16c.227-.573.34-1.24.34-2 0-.83-.34-1.5-.34-1.5s.003-.5.5-.5h2.503zM7 8a2 2 0 110-4 2 2 0 010 4zM4.997 9H7.5c.497 0 .5.5.5.5s-.34.67-.34 1.5c0 .76.113 1.427.34 2H2.5a.5.5 0 01-.5-.5v-.503A2.997 2.997 0 014.997 9zM12 14a3 3 0 110-6 3 3 0 010 6zm2.404 1C16.39 15 18 16.677 18 18.746v.629a.613.613 0 01-.6.625H6.6c-.331 0-.6-.28-.6-.625v-.629C6 16.677 7.61 15 9.596 15h4.808z"
            fill="currentColor"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
);

export default SvgIcnGroupCallBold;
